import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from "../../../forBinding";
import { getApiErrorMessage, toApiError } from "../utils";
import type { UpdateParcelamentoDTO, ParcelamentoAPI } from "@practium/features/parcelling";

export const useUpdateParcelling = () => {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async ({ _id, ...data }: UpdateParcelamentoDTO) => {
			try {
				return (
					await api.put<ParcelamentoAPI>(`/advices/parcelling/fixed/update/${_id}`, data, {
						params: { forBinding },
					})
				).data;
			} catch (error) {
				throw toApiError(error, "Erro ao atualizar parcelamento");
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ["parcelling"] });
			queryClient.invalidateQueries({ queryKey: ["parcelling", variables._id] });
		},
		onError: (error) => {
			console.error("Erro ao atualizar parcelamento:", getApiErrorMessage(error, "Erro ao atualizar parcelamento"));
		},
	});
};
